import { render } from "./PathsPage.vue?vue&type=template&id=3f7b75c2"
import script from "./PathsPage.vue?vue&type=script&lang=js"
export * from "./PathsPage.vue?vue&type=script&lang=js"

import "./PathsPage.vue?vue&type=style&index=0&id=3f7b75c2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__